<template>
	<div class="about4">
		<div class="about4-info">
			<div class="item">
				<div class="h">
					企业文化
				</div> 
				<div class="imgs">
					<div class="imgs-b">
						<img class="h-img" src="../../assets/ys/about/about1.png" alt="">
						<div class="t">
							使命
						</div>
						<div class="s">
							科技赋能，点亮绿色未来
						</div>
					</div>
					<div class="imgs-b">
						<img class="h-img" src="../../assets/ys/about/about2.png" alt="">
						<div class="t">
							愿景
						</div>
						<div class="s">
							成为国际一流的智慧能源系统<br>解决方案提供商
						</div>
						
					</div>
					<div class="imgs-b">
						<img class="h-img" src="../../assets/ys/about/about3.png" alt="">
						<div class="t">
							价值观
						</div>
						<div class="s">
							客赢共兴   协作担当
						</div>
						<div class="s">
							创新拼搏   追求卓越
						</div>
					</div>
				</div>
			</div>
		</div>
	    
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.about4 {
		background-color: white;
		justify-content: center;

			
			.about4-info {
				// min-width: 1200px;
				.item {
					.h {
						color: #332C2B;
						text-align: center;
					}
					
					.imgs {
						justify-content: space-between;
						flex-wrap: wrap;
						.imgs-b {
							  transition: transform 0.3s;
							img {
								
								background-color: #888;
							}
							.t {
								font-size:38px;
								color: #332C2B;
							}
							.s {
								font-size:24px;
								color: #332C2B;
							}
						}
						.imgs-b:hover {
						       transition: width 0.3s, height 0.3s;
						       transform: scale(0.95);
						       
						      }

					}
				}		
			}
	}
	
	@media screen and (min-width: 1200px) {
		.about4 {
			width: 100%;
			display: flex;
			padding: 80px 0;
				.about4-info {
					width: 1200px;
					.item {
						
						margin-bottom: 32px;
						.h {
							font-size: 44px;
						}
						
						.imgs {
							margin-top: 56px;
							display: flex;
							.imgs-b {
								background: #F4FBFD;
								width: calc(33.33% - 10px);
								padding-bottom: 30px;
								img {
									width: 100%;
									height: 562px;
								}
								.t {
									width: 100%;
									margin-top: 32px;
									font-size: 38px !important;
									font-weight:bold;
									text-align:center;
								}
								.s {
									margin-top: 16px !important;
									font-size: 24px !important;
									text-align:center;
								}
							}
						}
					}		
				}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.about4 {
			width: 100%;
			display: flex;
			padding: 50px 0;
				.about4-info {
					width: 100%;
					padding: 0 20px;
					.item {
						margin-bottom: 20px;
						.h {
							font-size: 30px;
						}
						
						.imgs {
							margin-top: 40px;
							display: flex;
							.imgs-b {
								width: calc(33.33% - 15px);
								padding-bottom: 20px;
								img {
									width: 100%;
									height:400px;
								}
								.t {
									width: 100%;
									margin-top: 20px;
									font-size: 20px;
								}
								.s {
									margin-top: 8px;
									font-size: 16px;
								}
							}
						}
					}		
				}
		}
	
	}
	@media screen and (max-width: 880px) {
		.about4 {
			width: 100%;
			display: flex;
			padding: 30px 0;
				.about4-info {
					width: 100%;
					padding: 0 8px;
					.item {
						margin-bottom: 15px;
						.h {
							font-size: 18px;
						}
						
						.imgs {
							margin-top: 15px;
							display: flex;
							.imgs-b {
								width: calc(50% - 4px);
								padding-bottom: 14px;
								img {
									width: 100%;
									height:220px;
								}
								.t {
									width: 100%;
									margin-top: 14px;
									font-size: 16px;
								}
								.s {
									margin-top: 5px;
									font-size: 14px;
								}
							}
						}
					}		
				}
		}
	
	}
</style>
